import { createMachine } from 'xstate';
import { Model } from 'xstate/lib/model.types';
import { BaseContext, BaseEvent, customElement, remoteMessage } from '../../../machine';
import React from 'react';

import { AddToMobileWalletFromGlobalData } from '../ZoryveDirect.components';

const WELCOME = 'WELCOME';
const CHECK_WITH_PHYSICIAN = 'CHECK_WITH_PHYSICIAN';
const ADD_TO_MOBILE_WALLET_EXISTING = 'ADD_TO_MOBILE_WALLET_EXISTING';
const QUESTIONS = 'QUESTIONS';

export const BENEFIT_MESSAGES = {
  WELCOME:
    'Arcutis Savings Card Program: You may be eligible to pay a lower copay for your ZORYVE (roflumilast) cream prescription.',
  CHECK_WITH_PHYSICIAN:
    'Check with your physician to see if a prior authorization has been submitted to your insurance.',
  ADD_TO_MOBILE_WALLET_EXISTING: <AddToMobileWalletFromGlobalData />,
  QUESTIONS:
    'Questions? Call 1-844-979-1288 from 6:00 am–5:00 pm PT, M–F. Text STOP to unsubscribe. Text TERMS for Terms and Conditions to 1-440-496-7983.',
};

/**
 * ZORYVE Direct Program Flow V2.0
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ZoryveDirectBenefitReminderFlow = (
  model: Model<BaseContext, BaseEvent, void>,
  initial = WELCOME
) =>
  createMachine<BaseContext, BaseEvent>({
    id: 'ZoryveDirectBenefitReminderFlow',
    initial: initial ?? WELCOME,
    context: model.initialContext,
    states: {
      // Welcome Message
      [WELCOME]: remoteMessage({
        id: WELCOME,
        message: BENEFIT_MESSAGES.WELCOME,
        nextState: CHECK_WITH_PHYSICIAN,
      }),

      [CHECK_WITH_PHYSICIAN]: remoteMessage({
        id: CHECK_WITH_PHYSICIAN,
        message: BENEFIT_MESSAGES.CHECK_WITH_PHYSICIAN,
        nextState: ADD_TO_MOBILE_WALLET_EXISTING,
      }),

      [ADD_TO_MOBILE_WALLET_EXISTING]: customElement({
        id: ADD_TO_MOBILE_WALLET_EXISTING,
        jsx: BENEFIT_MESSAGES.ADD_TO_MOBILE_WALLET_EXISTING,
        nextState: QUESTIONS,
      }),

      [QUESTIONS]: remoteMessage({
        id: QUESTIONS,
        message: BENEFIT_MESSAGES.QUESTIONS,
      }),
    },
  });
